<template>
    <div class="reportReservation defaultReport">
        <div class="filter-box">
            <div class="filter-bnts">
                <div class="inline-block">
                    <el-checkbox v-model="isPlaceOrderDate" label="下单日期:"/>
                    <el-date-picker class="from-date"
                        v-model="orderDate"
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="defaultTime"
                        :disabled="!isPlaceOrderDate"
                    > </el-date-picker>
                </div>
                <div class="inline-block">
                    <el-checkbox v-model="isServiceDate" label="预约送达日期:"/>
                    <el-date-picker class="from-date"
                        v-model="serviceDate"
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="defaultTime"
                        :disabled="!isServiceDate"
                    > </el-date-picker>
                </div>
                <div class="inline-block">
                    <div class="flex-box">
                        <div class="lable-txt">订单渠道:</div>
                        <div class="from-input" style="width: 180px;">
                           <el-select v-model="orderChannel" placeholder="全部" >
                                <el-option :value="0" label="全部"></el-option>
                                <el-option :value="1" label="美团"></el-option>
                                <el-option :value="2" label="饿了么"></el-option>
                                <el-option :value="3" label="自外卖"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="inline-block">
                    <div class="search-flex">
                        <div class="bnt-search" @click="loadData()" >查询</div>
                    </div>
                </div>
            </div>
            <div class="right-bnts">
                <div class="bnt" @click="exportExcel()"><i class="iconfont icon-daochu"></i>导出报表</div>
            </div>
        </div>
        <div class="content-box clearfix">
            <div class="nav-box-top">
                <div class="nav-box" v-mouse-scroll >
                    <div class="nav-li" :class="{selected:tagType==1}" @click="tagType=1">预约单统计表</div>
                    <div class="nav-li" :class="{selected:tagType==2}" @click="tagType=2">预约单菜品统计表</div>
                </div>
            </div>
            <div class="tab-pane" v-show="tagType==1">
                <div class="table-box grey-table isFooter" ref="tableBox">
                    <el-table class="el-table--scrollable-y"  :data="tableListPage"  border ref="elTable" 
                        @sort-change="sortChange" 
                        show-summary
                        :summary-method="getSummaries"
                        v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}">
                        <el-table-column label="序号" width="50" type="index">
                            <template #default="scope">{{scope.$index+1+(pagesize*(currentPage-1))}}</template>
                        </el-table-column>
                        <el-table-column sortable prop="FromType" label="订单渠道" min-width="80" align="left" ></el-table-column>
                        <el-table-column sortable prop="ExtOrderNo" label="平台单号" min-width="100" align="left" ></el-table-column>
                        <el-table-column sortable prop="OrderTime" label="下单时间"  min-width="130" :formatter="dateFormat"></el-table-column>
                        <el-table-column sortable prop="SendTime" label="预约送达时间"  min-width="130" :formatter="dateFormat"></el-table-column>
                        
                        <el-table-column sortable prop="OriginPrice" label="订单金额" min-width="80" align="right" :formatter="priceFormat" data-format="number"></el-table-column>
                        <el-table-column sortable prop="Price" label="客户实付" min-width="80" align="right" :formatter="priceFormat" data-format="number"></el-table-column>
                        <el-table-column sortable prop="MerchantPrice" label="商家实收" min-width="80" align="right" :formatter="priceFormat" data-format="number"></el-table-column>
                        <el-table-column prop="Address" label="送餐地址" min-width="200" align="left"></el-table-column>
                        <el-table-column prop="Remark" label="备注" min-width="120" align="left"></el-table-column>
                    </el-table>
                </div>
                <table-page-btn class="fy" :data="tableFilter" 
                    :default-index="currentPage" 
                    @current-change="(index)=>currentPage=index"
                    @page-change="(list)=>tableListPage=list" 
                    :page-size="pagesize"></table-page-btn>
            </div>
            <div class="tab-pane" v-show="tagType==2">
                <div class="table-box grey-table isFooter" ref="tableBox2">
                    <el-table class="el-table--scrollable-y"  :data="tableListPage2"  border ref="elTable2" 
                        @sort-change="sortChange2" 
                        show-summary
                        :summary-method="getSummaries2"
                        v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}">
                        <el-table-column label="序号" width="50" type="index">
                            <template #default="scope">{{scope.$index+1+(pagesize*(currentPage2-1))}}</template>
                        </el-table-column>
                        <el-table-column sortable prop="Upc" label="菜品编码" min-width="120" align="left" ></el-table-column>
                        <el-table-column sortable prop="Name" label="菜品名称" min-width="100" align="left" > </el-table-column>
                        <el-table-column sortable prop="Num" label="数量" min-width="100" align="right" :formatter="priceFormat" data-format="number"></el-table-column>
                        <el-table-column sortable prop="TotalPrice" label="金额" min-width="100" align="right" :formatter="priceFormat" data-format="number"></el-table-column>
                    </el-table>
                </div>
                <table-page-btn class="fy" :data="table2Filter" 
                :default-index="currentPage2" 
                @current-change="(index)=>currentPage2=index"
                @page-change="(list)=>tableListPage2=list" 
                :page-size="pagesize2"></table-page-btn>
            </div>
        </div>
    </div>
</template>

<script>
//外卖预约单统计表
export default {
    name:"reportReservation",
    data(){
        return {
            /**默认日期范围 */
            defaultTime:[new Date(),new Date()],
            //是否下单日期
            isPlaceOrderDate:true,
            //下单日期
            orderDate:[new Date(),new Date()],
            //是否预约送达日期
            isServiceDate:false,
            //预约送达日期
            serviceDate:[new Date(),new Date()],
            //订单渠道
            orderChannel:0,
            //1 预约单统计表  2预约单菜品统计表
            tagType:1,
            /**报表1 数据 */
            tableList:[],
            /**报表1 分页数据 */
            tableListPage:[],
            currentPage:1,
            pagesize:10,
            /**报表2 数据 */
            table2List:[],
            /**报表2 分页数据 */
            tableListPage2:[],
            currentPage2:1,
            //每页的数据条数
            pagesize2:10,
            sortable:null,
            sortable2:null,
        }
    },
    computed:{
        //合计
        total(){
            let total={
                OriginPrice:0,
                Price:0,
                MerchantPrice:0,
            };
            (this.tableList||[]).forEach(it=>{
                total.OriginPrice+=it.OriginPrice;
                total.Price+=it.Price;
                total.MerchantPrice+=it.MerchantPrice;
            })
            return total;
        },
        //合计
        total2(){
            let total={
                Num:0,
                TotalPrice:0,
            };
            (this.table2List||[]).forEach(it=>{
                total.Num+=it.Num;
                total.TotalPrice+=it.TotalPrice;
            })
            return total;
        },
        /**预约单统计表 排序*/
        tableFilter(){
            let list=this.tableList;
            //排序
            if(this.sortable){
                let sorttype=this.sortable.order=='ascending'?'asc':'desc';
                list.order(this.sortable.prop,sorttype);
            }
            return list;
        },
        /**预约单菜品统计表 排序 */
        table2Filter(){
            let list=this.table2List;
            //排序
            if(this.sortable2){
                let sorttype=this.sortable2.order=='ascending'?'asc':'desc';
                list.order(this.sortable2.prop,sorttype);
            }
            return list;
        }
    },
    watch:{
        tagType(){
            if(this.tagType==1){
                this.setTablePageSize();
            }else{
                this.setTablePageSize2();
            }
        }
    },
    methods:{
        /**Excel导出 */
        exportExcel(){
            if(!this.$cacheData?.globalVariable?.GlobalSysSetting.AllowUserPrintReports){
                this.$message.warning('您没有导出报表权限，请先分配权限！');
                return;
            }
            if(this.tagType==1){
                this.$excelCommon.elTableToExcel({
                    elTable:this.$refs.elTable,
                    titleName:"预约单统计表",
                    list:this.tableFilter,
                })
            }else{
                this.$excelCommon.elTableToExcel({
                    elTable:this.$refs.elTable2,
                    titleName:"预约单菜品统计表",
                    list:this.table2Filter,
                })
            }
        },
        /*时间格式 */
        dateFormat(row, column, cellValue) {
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd hh:mm:ss');
        },
        /*单价格式 截取两位小数 */
        priceFormat(row, column, cellValue){
            if(isNaN(cellValue)){
                return ""
            }else{
                return parseFloat(parseFloat(cellValue).toFixed(2));
            }
        },
        /**数据排序 */
        sortChange(column){
            this.sortable=column;
        },
        /**数据排序 */
        sortChange2(column){
            this.sortable2=column;
        },
        /**计算 一页显示多少条数据 */
        setTablePageSize(){
            if(this.$refs.tableBox){
                this.$nextTick(()=>{
                    let height=this.$refs.tableBox.clientHeight - 80;
                    this.pagesize=parseInt(height/50);
                })
            }
        },
        /**计算 一页显示多少条数据 */
        setTablePageSize2(){
            if(this.$refs.tableBox2){
                this.$nextTick(()=>{
                    let height=this.$refs.tableBox2.clientHeight - 80;
                    this.pagesize2=parseInt(height/50);
                })
            }
        },
        getSummaries({ columns, data }){
            const sums= [];
            columns.forEach((column, index) => {
                if(this.total[column.property]!=undefined){
                    sums[index]=this.priceFormat(null,null,this.total[column.property]);
                }else{
                    sums[index]="";
                }
            })
            sums[0]="合计";
            return sums;
        },
        getSummaries2({ columns, data }){
            const sums= [];
            columns.forEach((column, index) => {
                if(this.total2[column.property]!=undefined){
                    sums[index]=this.priceFormat(null,null,this.total2[column.property]);
                }else{
                    sums[index]="";
                }
            })
            sums[0]="合计";
            return sums;
        },
        /**查询 */
        loadData(){
            if(!this.isPlaceOrderDate && !this.isServiceDate){
                this.$message.warning("请勾选下单日期或预约送达日期进行查询！");
                return;
            }
            let userInfo = this.$auth.getUserInfo();
            let param={
                User_ID:userInfo?.User_ID,
                Operator_Name:userInfo?.Login_Name,
                FromType:this.orderChannel,//订单渠道
            }
            if(this.isPlaceOrderDate){
                let time = JSON.parse(JSON.stringify(this.orderDate));
                param.OrderTime_BDate=new Date(time[0]).Format("yyyy-MM-dd");//开始日期
                param.OrderTime_EDate=new Date(time[1]).Format("yyyy-MM-dd");//结束日期

                if((new Date(param.OrderTime_EDate)-new Date(param.OrderTime_BDate))/(1000*60*60*24)>30){//
                    this.$message.warning("下单日期查询不能超过31天！");
                    return;
                }
                param.OrderTime_EDate=param.OrderTime_EDate+" 23:59:59"
            }
            if(this.isServiceDate){
                let time = JSON.parse(JSON.stringify(this.serviceDate));
                param.SendTime_BDate=new Date(time[0]).Format("yyyy-MM-dd");//开始日期
                param.SendTime_EDate=new Date(time[1]).Format("yyyy-MM-dd");//结束日期
                if((new Date(param.SendTime_EDate)-new Date(param.SendTime_BDate))/(1000*60*60*24)>30){//
                    this.$message.warning("预约送达日期查询不能超过31天！");
                    return;
                }
                param.SendTime_EDate=param.SendTime_EDate+" 23:59:59"
            }
            console.log(param)
            const loading = this.$loading({
                text: "查询中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.ReservationOrderReport",param).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    //预约单统计表
                    this.tableList=d.ResponseBody.ReservationOrderReports;
                    //预约单菜品统计表
                    this.table2List=d.ResponseBody.ReservationOrderFoodReports;
                    if(this.tagType==1){
                        this.setTablePageSize();
                    }else{
                        this.setTablePageSize2();
                    }
                    this.currentPage=1;
                    this.currentPage2=1;
                }else{
                    this.tableList=[];
                    this.table2List=[];
                    this.currentPage=1;
                    this.currentPage2=1;
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                this.tableList=[];
                this.table2List=[];
                this.currentPage=1;
                this.currentPage2=1;
                loading.close();
                this.$message.error(e.message);
                console.log(e);
            })
        },
    }
}
</script>

<style lang="scss" >
@import './reportReservation.scss'
</style>